import { sanitizeHtmlString } from 'utils'
import { registerType } from '../types'

interface InputInterface {
  registerOptions?: registerType
  register: Function
  value?: string | number
  assistiveText?: string
  errorMessage?: string
  name: string
  id?: string
  type?: string
  label?: string
  placeholder?: string
  defaultValue?: string | number
  short?: boolean
}
export default function Input({
  value,
  assistiveText,
  name,
  id,
  label,
  type = 'text',
  errorMessage,
  placeholder,
  register,
  registerOptions,
  defaultValue,
  short
}: InputInterface) {
  const inputClass = errorMessage ? 'input-primary input-validation-error' : 'input-primary'
  return (
    <div
      className={`wc-form-item${
        short ? ' wc-form-item w-auto sm:w-5/12 md:w-6/12 lg:w-5/12' : ''
      }`}
    >
      <label htmlFor={id ?? name} className="label-primary">
        {label}
      </label>
      {assistiveText && <span className="wc-assist">{assistiveText}</span>}
      {errorMessage && (
        <span
          className="field-validation-error wc-assist wc-assist--error"
          role="alert"
          dangerouslySetInnerHTML={sanitizeHtmlString(errorMessage)}
        />
      )}
      <input
        data-testid={id}
        id={id ?? name}
        {...register(name, registerOptions)}
        name={name}
        value={value}
        className={inputClass}
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        min={0}
      />
    </div>
  )
}
